/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { useToast } from '../../../components/Toats';
import { StepperComponent } from '../../../../../_metronic/assets/ts/components';
import { getProposalOne } from '../../../../services/proposalsService';
import { Loading } from '../../../components/Loadings/loading';
import { KTSVG } from '../../../../../_metronic/helpers';
import { MenuAddEditProposal } from '../MenuModalAddEditProposal';

type Props = {
    id?: string;
    data?: any;
    show: boolean;
    setMyProposal: any
    handleClose: () => void
    refresh?: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddEditV2 = ({show, handleClose, id, data, setMyProposal, refresh}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  const [proposal, setProposal] = useState<any>(null);

  // const getProposal = async () => {
  //   try {
  //     if(id){
  //       setLoading(true)
  //       const myProposal = await getProposalOne(id ? id : "")
  //       setProposal(myProposal)
  //     }
  //   } catch (error) {
  //       console.log(error)
  //       toggleToast("Erro ao buscar a proposta. ", "error")
  //   }finally{
  //       setLoading(false)
  //   }
  // }
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  // const refresh = () => {
  //   getProposal()
  // }


  useEffect(() => {
    //getProposal()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  if (loading) {
    return (
      <div className='spinnerLoadingDashboard'>
        <Loading myClass='spinner-border spinnerDashboard'/>
      </div>
    );
  }


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
      style={{minWidth: '1000px'}}
    >

      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{id ? "Editar" : "Adicionar"} Proposta {" "}</span>
          {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      
      <div className='modal-body py-lg-10 px-lg-10 bg-light'>
        <MenuAddEditProposal 
          closed={closed}
          proposal={proposal ? proposal : null}
          data={data ? data : null}
          setProposal={setMyProposal}
          refresh={refresh}
        />
      </div>

    </Modal>,
    modalsRoot
  )
}

export {ModalAddEditV2}
